<template>
  <div class="text-menu" @scroll="handleScroll">
    <MenuHeader title="文本" />
    <div class="text-clip-list-group">
      <div class="text-clip-list">
        <menu-button class="text-clip-list-button" @click="addTextItem">
          <span class="icon iconfont icon-add-fill text-add"></span>
          添加文本
        </menu-button>
        <el-tooltip>
          <template slot="content">
            文本编辑建议优先使用英文，部分字体不支持小语种编辑
          </template>
          <a-icon
            type="question-circle"
            class="text-clip-group__tooltip"
            theme="filled"
          />
        </el-tooltip>
        <a-radio-group
          class="text-type-radio-group"
          v-model="type"
          button-style="solid"
        >
          <a-radio-button value="combination">组合文本</a-radio-button>
          <a-radio-button value="wordart">艺术字</a-radio-button>
        </a-radio-group>
        <!-- <h3 class="text-clip-group__header">组合文本</h3> -->
        <a-spin
          :spinning="loadingStatus === 'loading'"
          class="video-template-list"
          v-if="type === 'combination'"
        >
          <a-empty
            v-if="!presets.length && loadingStatus !== 'loading'"
            :style="{
              margin: '32px 30px 0 0',
              flexGrow: 1,
              opacity: loadingStatus === 'loading' ? 0 : 1,
              transition: '.3s'
            }"
            :image="defaultImage"
          />
          <div
            v-for="item in presets"
            :key="item.id"
            class="video-template-item"
            @click="addPresetItem(item.id)"
          >
            <img
              v-if="item.attribute_name == '标准'"
              title="标准"
              class="meal-icon"
              src="/preview/icon/user_meal1.png"
              alt="标准"
            />
            <img
              v-else-if="item.attribute_name == '专业'"
              class="meal-icon"
              title="专业"
              src="/preview/icon/user_meal2.png"
              alt="专业"
            />
            <img
              v-else-if="item.attribute_name == '旗舰'"
              class="meal-icon"
              title="旗舰"
              src="/preview/icon/user_meal3.png"
              alt="旗舰"
            />
            <img
              v-if="item.thumbnail"
              :src="item.thumbnail + '?x-oss-process=image/resize,w_216'"
              alt="Preset Preview"
              class="video-clip-custom-img"
            />
            <div v-else class="video-clip-custom-img" />
            <div :title="item.name" class="video-clip-custom-title">
              {{ item.name }}
            </div>
          </div>
        </a-spin>
        <a-spin class="video-template-list" :spinning="false" v-else>
          <div
            v-for="item in wordArtList"
            :key="item.type"
            class="video-template-item"
            @click="addWordArtItem(item.type)"
          >
            <img
              v-if="item.thumbnail"
              :src="item.thumbnail + '?x-oss-process=image/resize,w_216'"
              alt="Preset Preview"
              class="video-clip-custom-img"
              style="background: #fff"
            />
            <div v-else class="video-clip-custom-img" />
            <div :title="item.name" class="video-clip-custom-title">
              {{ item.name }}
            </div>
          </div>
        </a-spin>
        <!-- <div class="text-clip-group">
          <div
            v-for="textItem in textItemList"
            :key="textItem.id"
            :class="[
              'text-clip-group-txt',
              { 'text-mean-active': selectedEffectId === textItem.id }
            ]"
            @click="handleCurrentText(textItem.id)"
          >
            <div class="text-clip-tip" v-if="textItem.dynamictext">
              动态文本
            </div>
            <div class="text-clip-txt">文本: {{ textItem.value }}</div>
            <div class="text-clip-op">
              <div v-for="op in opList" :key="op.id">
                <button
                  type="button"
                  v-if="op.opTextbtn"
                  :class="op.attr"
                  :title="op.title"
                  class="icon iconfont"
                  @click="operate($event, op.type, textItem.id)"
                ></button>
              </div>
            </div>
          </div>
        </div> -->
      </div>
    </div>

    <!-- <div class="subtitle-clip-tip">
      <div class="subtitle-clip-tip-title">
        <span class="icon iconfont icon-gantanhao"></span>提示：
      </div>
      <div class="subtitle-clip-tip-text">
        文本编辑建议优先使用英文，部分字体不支持小语种编辑
      </div>
    </div> -->
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import MenuHeader from '../base/MenuHeader';
import MenuButton from '../base/MenuButton';
import { Empty } from 'ant-design-vue';

export default {
  name: "TextMenu",
  components: { MenuHeader, MenuButton },
  data: function () {
    return {
      opList: [
        { id: '1', title: '删除', attr: 'deleteBtn icon-delete1', 'opTextbtn': true, type: 'delete' },
        // { id: '2', title: '隐藏', attr: 'hideBtn icon-ziyuan78', 'opTextbtn': true },
        // { id: '3', title: '锁定', attr: 'lockBtn icon-suoding1', 'opTextbtn': true },
      ],
      loadingStatus: 'loading',
      defaultImage: Empty.PRESENTED_IMAGE_SIMPLE,
      type: 'combination',
      wordArtList: [
        {
          type: 'coloredStroke',
          name: '多色描边文本',
          thumbnail: 'https://aivideo8.oss-cn-hongkong.aliyuncs.com/ai_video/U449/2021-01-14/img/1610604314344.png'
        },
        {
          type: 'shadowFade',
          name: '长阴影文本',
          thumbnail: 'https://aivideo8.oss-cn-hongkong.aliyuncs.com/ai_video/U449/2021-01-14/img/1610614216205.png'
        }
      ],
      presetPage: 1,
      lastPage: ''
    }
  },
  computed: {
    ...mapState(['presets', 'screenRatio']),
    textItemList() {
      const frag = this.$store.getters.activeFragment;
      const allEffects = this.$store.state.effects;
      return frag.effects.filter(efid => allEffects[efid].type === 'text').map(efid => {
        const ef = allEffects[efid];
        return {
          id: efid,
          dynamictext: ef.showTracks,
          value: ef.content.name || ef.content.text
        };
      });
    },
    selectedEffectId() {
      return this.$store.getters.selectedEffectId;
    }
  },
  methods: {
    ...mapActions(['processRemoveMaterialItem', 'getPresetList', 'addPresetItem', 'addWordArtItem']),
    handleCurrentText: function (event) {
      this.$store.commit('handleTimelineFilter', '');
      this.$store.commit('handleEffectSelect', [event]);
    },
    addTextItem() {
      this.$store.dispatch('addTextItem');
    },
    async operate(e, type, id) {
      console.log(id);
      e.stopPropagation();
      const selected = id === this.selectedEffectId;
      switch (type) {
        case 'delete': {
          const done = await this.processRemoveMaterialItem(id);
          if (selected && done) {
            this.$store.commit('handleEffectSelect', []);
          }
        }
          break;
        default:
          console.log('unsupported operation type: ' + type);
      }
    },
    fetchPresets(page) {
      this.loadingStatus = 'loading';
      this.getPresetList({ type: 6, page }).then(val => {
        if (val) {
          this.loadingStatus = 'loaded';
          this.presetPage = page;
          this.lastPage = val.lastPage;

          setTimeout(this.handleScroll, 300);
        }
      });
    },
    handleScroll() {
      const menu = this.$el;
      if (this.lastPage || this.loadingStatus === 'loading' || this.type !== 'combination') {
        return;
      }
      if (menu.scrollTop + menu.clientHeight >= menu.scrollHeight - 30) {
        this.fetchPresets(this.presetPage + 1);
      }
    }
  },
  mounted() {
    this.fetchPresets(1);
  },
  watch: {
    screenRatio() {
      if (this.type === 'combination') {
        this.fetchPresets(1);
      }
    },
    type(val) {
      if (val === 'combination') {
        this.fetchPresets(1);
      }
    }
  }
}
</script>

<style scoped>
.text-menu {
  background: rgba(247, 248, 249, 1);
  box-shadow: -1px 0 0 0 rgba(220, 220, 222, 1);
  padding: 10px 18px;
  height: 100%;
  overflow-y: auto;
}

.text-clip-list-group {
  position: relative;
}

.text-clip-list,
.text-clip-group {
  display: flex;
  flex-direction: column;
}

.text-clip-list-button {
  margin: 10px 0 0;
}

.text-clip-list-button .icon {
  font-size: 20px;
  margin-right: 5px;
}
.text-clip-group {
  width: 100%;
  margin-top: 10px;
  position: relative;
}

.text-clip-group__tooltip {
  color: #fff;
  position: absolute;
  /* align the icon above the button */
  right: 12px;
  top: 23px;
}

.text-clip-group-active {
  border: 1px solid rgba(0, 126, 255, 1);
}

.text-clip-group-txt {
  width: 100%;
  height: 52px;
  padding: 14px;
  background: #fff;
  border: 1px solid #e5e5e7;
  border-radius: 2px;
  color: rgba(101, 102, 103, 1);
  line-height: 22px;
  font-size: 16px;
  text-align: center;
  margin-bottom: 10px;
  cursor: pointer;
  position: relative;
  z-index: 0;
}

.text-clip-group-txt:hover,
.text-clip-group-txt.text-mean-active {
  border: 1px solid rgba(0, 126, 255, 1);
}

.text-clip-tip {
  width: 62px;
  height: 22px;
  line-height: 22px;
  text-align: center;
  opacity: 0;
  transition: 0.2s;
  position: absolute;
  top: 50%;
  left: 10px;
  margin-top: -11px;
  background: rgba(245, 166, 35, 1);
  border-radius: 4px;
  font-size: 10px;
  padding: 0 7px;
  color: #fff;
  box-shadow: 5px 0 6px -3px #fff;
}

.text-clip-txt {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.text-clip-op {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  opacity: 0;
  transition: 0.2s;
  position: absolute;
  right: 10px;
  top: 50%;
  margin-top: -12px;
  background: linear-gradient(to right, transparent, #fff 24px);
  padding-left: 10px;
}
.text-clip-group-txt:hover .text-clip-tip,
.text-clip-group-txt:hover .text-clip-op {
  opacity: 1;
}
.text-clip-op .icon {
  font-size: 14px;
  color: #5f5f5f;
  margin: 0 0 0 8px;
  text-align: center;
  padding: 0 4px;
  border: 0;
  background: transparent;
  outline: none;
}
.text-clip-op .icon.icon-suoding1 {
  font-weight: bold;
}

.text-clip-group .icon:hover,
.text-clip-group .icon:focus {
  color: #007eff;
}

.subtitle-clip-tip {
  line-height: 18px;
  padding: 5px 0;
  font-size: 12px;
}

.subtitle-clip-tip-title {
  color: #122037;
  margin: 10px 0 0 0;
}

.subtitle-clip-tip-title .icon {
  color: #e4b634;
  font-size: 14px;
  margin-right: 5px;
  display: inline-block;
}

.subtitle-clip-tip-text {
  margin-top: 5px;
}

.text-type-radio-group {
  margin-top: 12px;
  display: flex;
}

.text-type-radio-group .ant-radio-button-wrapper {
  flex: 1 0 1px;
  text-align: center;
  height: 30px;
  line-height: 28px;
}

.text-clip-group__header {
  font-size: 12px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  padding-bottom: 6px;
  margin: 12px 0 0;
}

.video-template-item {
  margin: 12px 14px 6px 0;
  width: calc(50% - 14px);
  position: relative;
  cursor: pointer;
}

.meal-icon {
  width: 20px;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 1;
}

.video-clip-custom-img {
  object-fit: cover;
  width: 100%;
  height: 60px;
  transition: 0.2s;
}

.video-clip-custom-title {
  text-align: center;
  font-size: 12px;
  font-weight: 400;
  margin: 4px 0 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.video-template-item:hover {
  color: #007eff;
}

.video-template-item:hover .video-clip-custom-img {
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.06), 0 0 8px rgba(0, 0, 0, 0.1);
}
</style>
